import { Can } from "@/casl-provider";
import { CasaviContactBlacklistTable } from "@/components/data-table/predefined/casavi-contact-blacklist-table";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { getCasaviContactBlacklistColumns } from "@/modules/casavi/_helpers/table-columns";
import { useTranslation } from "react-i18next";

const DEFAULT_PAGE_SIZE = 100;

export function CasaviContactBlacklistView() {
  const { t } = useTranslation(["casavi", "common"]);
  return (
    <Can I="read" a="CasaviContactBlacklist">
      <CenteredLayout
        variant={CenteredLayoutVariant.Table}
        title={t("casavi:ContactBlacklist")}
        subTitle={t("casavi:CasaviContactBlacklistDescription")}
      >
        <CasaviContactBlacklistTable
          columns={getCasaviContactBlacklistColumns()}
          pageSize={DEFAULT_PAGE_SIZE}
          createButtonLink="~/cas/contact-blacklist/create"
        />
      </CenteredLayout>
    </Can>
  );
}
